import {http} from '@/helpers/http-helper';

export const getContacts = () => {
  return new Promise( (resolve, reject) => {
    const url = 'contacts';
    http.get(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteContact = (contactId) => {
  return new Promise( (resolve, reject) => {
    const url = 'contacts/' + contactId;
    http.delete(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateContact = (uuid, properties) => {
  return new Promise( (resolve, reject) => {
    const url = 'contact/' + uuid;
    http.post(url, properties)
      .then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        } else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const unsubscribeContact = (requestObject) => {
  return new Promise( (resolve, reject) => {
    const url = 'public/contact/unsubscribe';
    http.post(url, requestObject.data)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
